var map = {
	"./air-conditioner.svg": 1389,
	"./airplane.svg": 1390,
	"./airport.svg": 1391,
	"./approved.svg": 1392,
	"./aquapark.svg": 1393,
	"./arrow-answer-bubble.svg": 1394,
	"./arrow-back.svg": 1395,
	"./arrow-flight.svg": 1396,
	"./arrow-right-top.svg": 1397,
	"./arrow-right.svg": 1398,
	"./bar.svg": 1399,
	"./beach-surface-pebble.svg": 1400,
	"./beach-surface-platform.svg": 1401,
	"./beach-surface-sand-pebble.svg": 1402,
	"./beach-surface-sand.svg": 1403,
	"./beachsurface.svg": 1404,
	"./card.svg": 1405,
	"./check.svg": 1406,
	"./clock.svg": 1407,
	"./cvv.svg": 1408,
	"./double-arrow.svg": 1409,
	"./empty-hotel-map.svg": 1410,
	"./filters/clear-filters.svg": 1411,
	"./filters/filter-button.svg": 1412,
	"./filters/instant-confirm-colored.svg": 1413,
	"./filters/instant-confirm.svg": 1414,
	"./filters/search-distance.svg": 1415,
	"./filters/search-lift.svg": 1416,
	"./fire.svg": 1417,
	"./flight-direct-mobile.svg": 1418,
	"./flight-direct.svg": 1419,
	"./flight-direct__additional-mobile.svg": 1420,
	"./flight-direct__additional.svg": 1421,
	"./flight-transition-mobile.svg": 1422,
	"./flight-transition.svg": 1423,
	"./flight-transition__additional-mobile.svg": 1424,
	"./flight-transition__additional.svg": 1425,
	"./food.svg": 1426,
	"./free-cancellation-colored.svg": 1427,
	"./fuel-green.svg": 1428,
	"./fuel-white.svg": 1429,
	"./funicular.svg": 1430,
	"./gallery-empty.svg": 1431,
	"./garranty.svg": 1432,
	"./gender-female.svg": 1433,
	"./gender-male.svg": 1434,
	"./gender-unidentified.svg": 1435,
	"./gift.svg": 1436,
	"./glass.svg": 1437,
	"./gym.svg": 1438,
	"./hand-luggage.svg": 1439,
	"./heated-pool.svg": 1440,
	"./hold-luggage.svg": 1441,
	"./hotel-reply.svg": 1442,
	"./included-services.svg": 1443,
	"./included.svg": 1444,
	"./kids-club.svg": 1445,
	"./kids-menu.svg": 1446,
	"./kids-pool.svg": 1447,
	"./lightning.svg": 1448,
	"./lock.svg": 1449,
	"./logo.svg": 1450,
	"./lt-extra/bonus_insurance.svg": 1451,
	"./lt-extra/bonus_ivi.svg": 1452,
	"./luggage-wrapping.svg": 1453,
	"./man.svg": 1454,
	"./map-button.svg": 1455,
	"./map/collapse-arrows.svg": 1456,
	"./map/expand-arrows.svg": 1457,
	"./massage.svg": 1458,
	"./nanny.svg": 1459,
	"./only-lt-half.svg": 1460,
	"./parking.svg": 1461,
	"./payment-mir.svg": 1462,
	"./paymenttype.svg": 1463,
	"./plane-arrival.svg": 1464,
	"./plane.svg": 1465,
	"./private-beach.svg": 1466,
	"./rest_types/active.svg": 1467,
	"./rest_types/couples.svg": 1468,
	"./rest_types/family.svg": 1469,
	"./review-tab-selected.svg": 1470,
	"./sauna.svg": 1471,
	"./search-sorting.svg": 1472,
	"./searcher-empty-request.svg": 1473,
	"./searcher-filtered-empty.svg": 1474,
	"./sidebar-bottom-triangle.svg": 1475,
	"./sidebar-menu-active.svg": 1476,
	"./sign_additional.svg": 1477,
	"./ski-in-ski-out.svg": 1478,
	"./social-fb.svg": 1479,
	"./social-share.svg": 1480,
	"./social-vk.svg": 1481,
	"./special.svg": 1482,
	"./success_additional.svg": 1483,
	"./swimming-pool.svg": 1484,
	"./thumbs-up.svg": 1485,
	"./wave.svg": 1486,
	"./wifi.svg": 1487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 875;